import HomePage from "../../pages/home";
import ExplorePage from "../../pages/explore";
export var Default_Routes = [
    {
        PATH: '/',
        COMPONENT: HomePage,
        isProtected: false,
    },
    {
        PATH: '/explore',
        COMPONENT: ExplorePage,
        isProtected: false,
    },
    /*
    {
      PATH: '/*',
      COMPONENT: <PageNotFound />,
      isProtected: false,
    }, */
];
